// extracted by mini-css-extract-plugin
export default {"no-tasks-icon":"TasksKanbanColumn_no-tasks-icon__RmjZ5"};